import axios from "axios";
import React, { useEffect, useState } from "react";
import logo from "../../assets/logos/newLogo.png";
import { API_URL } from "../../url/api";
import { FiEye, FiEyeOff } from "react-icons/fi";

const ResetPassword: React.FC = () => {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);

    const key = urlParams.get("key") || "";

    if (key === "") checkUserLoggedIn();
      
  }, []);

  const checkUserLoggedIn = () => {
    const userId = localStorage.getItem("userId");
    const doctorId = localStorage.getItem("doctorId");
    if (userId) 
      window.location.href = "/dashboard/";
    else if (doctorId)
      window.location.href = "doctor/dashboard/";
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }
    console.log("handleSubmit:", password, confirmPassword);

    setIsLoading(true);
    try {
      const token = new URLSearchParams(window.location.search).get("token");
      if (!token) {
        setError("Invalid or missing token");
        setIsLoading(false);
        return;
      }
      const response = await axios.post(`${API_URL}reset-password/`, {
        password,
        token,
      });
      if (response.data.success) {
        localStorage.clear();
        setSuccess("Password reset successful. Redirecting...");
        setError("");
        setTimeout(() => {
          window.location.href = "/";
        }, 2000); // Redirect after 2 seconds
      }
    } catch (error) {
      console.error("Reset password API error:", error);
      setError("An error occurred");
      setSuccess("");
    }
    setIsLoading(false);
  };

  if (success) {
    return (
      <div className="min-h-screen bg-gray-200 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md ">
          <img className="mx-auto h-12 w-auto" src={logo} alt="Outss Logo" />
          <h2 className="mt-6 text-center text-xl leading-9 font-extrabold text-gray-900">
            Reset Password
          </h2>
        </div>
        <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
          <div className="bg-white py-8 px-4 mx-4 md:mx-0 rounded-lg shadow sm:px-10">
            <div className="text-green-500 text-sm mb-4 text-center">
              {success}
            </div>
          </div>
        </div>
      </div>
    );
  }

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{8,})/;

  const handlePasswordChange = (password: string) => {
    console.log(
      "handlePasswordChange:",
      password,
      passwordRegex.test(password)
    );

    setPassword(password);
    if (password === "") setError("Please enter a password");
    else if (password.length < 8)
      setError("Password must be at least 8 characters long");
    else if (!passwordRegex.test(password))
      setError(
        "Password must contain at least one uppercase letter, one lowercase letter, and one number"
      );
    else setError("");
  };

  const handleConfirmPasswordChange = (confirmPassword: string) => {
    setConfirmPassword(confirmPassword);
    if (confirmPassword === "") setError("Please confirm your password");
    else if (password !== confirmPassword) setError("Passwords do not match");
    else setError("");
  };

  const isButtonValid =
    password === "" ||
    confirmPassword === "" ||
    isLoading ||
    error !== "" ||
    password !== confirmPassword;

  return (
    <div className="min-h-screen bg-gray-200 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <img className="mx-auto h-12 w-auto" src={logo} alt="Logo" />
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
          Reset Password
        </h2>
      </div>

      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                New Password
              </label>
              <div className="mt-1 relative">
                <input
                  id="password"
                  name="password"
                  type={showPassword ? "text" : "password"}
                  autoComplete="current-password"
                  required
                  value={password}
                  onChange={(e) => handlePasswordChange(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                />
                <button
                  type="button"
                  className="absolute right-2 top-2 focus:outline-none"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <FiEyeOff className="h-5 w-5 text-gray-400" />
                  ) : (
                    <FiEye className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
            </div>

            <div>
              <label
                htmlFor="password"
                className="block text-sm font-medium text-gray-700"
              >
                Confirm Password
              </label>
              <div className="mt-1 relative">
                <input
                  id="password"
                  name="password"
                  type={showConfirmPassword ? "text" : "password"}
                  autoComplete="current-password"
                  required
                  value={confirmPassword}
                  onChange={(e) => handleConfirmPasswordChange(e.target.value)}
                  className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm"
                />
                <button
                  type="button"
                  className="absolute right-2 top-2 focus:outline-none"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <FiEyeOff className="h-5 w-5 text-gray-400" />
                  ) : (
                    <FiEye className="h-5 w-5 text-gray-400" />
                  )}
                </button>
              </div>
            </div>

            {error && <div className="text-red-500 mt-2 text-sm">{error}</div>}

            <div>
              <button
                type="submit"
                disabled={isButtonValid}
                className="w-full flex justify-center disabled:opacity-60 py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-primary hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
              >
                {isLoading ? "Resetting..." : "Reset Password"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
